<artemis-breadcrumbs [breadcrumbs]="breadcrumbs | async"></artemis-breadcrumbs>
<artemis-customer-overview-card></artemis-customer-overview-card>
<div class="edit-customer-card" id="editCustomerCard">
  <artemis-loading-spinner *ngIf="(customerDataLoading$ | async) || formLoading"></artemis-loading-spinner>
  <div [style.visibility]="customer ? 'visible': 'hidden'" ubi-curve-header class="edit-customer-card__header">
    <span class="edit-customer-card__header-text"> {{ 'edit_customer.header' | translate }} </span>
  </div>
  <artemis-popover>
    <ng-container *ngFor="let section of ('edit_customer.info.content' | translate)">
      <ng-container *ngFor="let content of section.paragraph">
        <p>{{content}}</p>
      </ng-container>
    </ng-container>
  </artemis-popover>
  <div class="edit-customer-card__content-container">
    <div class="edit-customer-card__subsection edit-customer-card__subsection_no-padding">
      <artemis-details-form [isPrimary]="true" [customerCrpData]="customer" (formDataChanged)="formChange($event)" (loading)="formLoadingHandler($event)"  [dataAvaliableFormFields]="dataAvaliableFormFields">
      </artemis-details-form>
    </div>
    <div class="edit-customer-card__btns-container">
      <div class="edit-customer-card__msg-container">
        <div class="edit-customer-card__hint-msg">
          <div *ngIf="hasFormerOrAliasName()"> {{ 'customer_info.message.alias_or_former_name_credit_consumption' | translate }} </div>
        </div>
        <div class="edit-customer-card__error-msg" [hidden]="!triedSubmit">
          <div [hidden]="isFormValid()"> {{ 'edit_customer.text' | translate }} </div>
        </div>
      </div>
      <button class="btn btn_rounded edit-customer-card__submit-btn" mat-button ubi-round-button
              (click)="updateCustomer()" [disabled]="!isFormValid()">
        {{ 'edit_customer.button.update' | translate }}
      </button>
      <button class="btn btn_accent-gradient-rounded edit-customer-card__submit-btn" mat-button ubi-round-button
              *ngIf="customerType === 'CORPORATE'" (click)="updateCustomer('crp')">
        {{ 'edit_customer.button.update_and_add_crp' | translate }}
      </button>
      <button class="btn btn_accent-gradient-rounded edit-customer-card__submit-btn" mat-button ubi-round-button
              (click)="updateCustomer('ra')">
        {{ 'edit_customer.button.complete_and_submit_for_screening' | translate }}
      </button>
    </div>
    <div class="edit-customer-card__subsection" *ngIf="otherData">
      <div class="edit-customer-card__subsection-title">
        {{ 'edit_customer.title.other_info' | translate }}
      </div>
      <artemis-customer-other-data [rawOtherData]="otherData" [editMode]="true"></artemis-customer-other-data>
    </div>
  </div>
</div>
<div #customerDocument>
  <artemis-customer-document [record]="customer?.record" (uploaded)="getCRPS()"></artemis-customer-document>
</div>
<artemis-crp-list-card></artemis-crp-list-card>
